import { render, staticRenderFns } from "./AccountRegister.vue?vue&type=template&id=70012e16&scoped=true&lang=pug"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70012e16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70012e16')) {
      api.createRecord('70012e16', component.options)
    } else {
      api.reload('70012e16', component.options)
    }
    module.hot.accept("./AccountRegister.vue?vue&type=template&id=70012e16&scoped=true&lang=pug", function () {
      api.rerender('70012e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/account/AccountRegister.vue"
export default component.exports